import { tdsFetch } from '@/utils/fetch'

export const reportUsageHeartbeat = (data, options = {}) => {
  return tdsFetch('/usage/heartbeat', {
    method: 'POST',
    body: data,
    ...options,
  })
}
